<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Thêm mới Lớp học</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row :gutter="10">
      <div class="model-content">
        <el-form label-position="top" :rules="rules" :model="modelData" ref="createModel">
          <el-col :span="8">
            <el-form-item prop="school_id" label="Chọn trường" class="form-item">
              <el-select v-model="modelData.school_id" filterable placeholder="" class="input-select">
                <el-option
                  v-for="item in lists.listSchool"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="level_id" label="Chọn phân hệ" class="form-item">
              <el-select v-model="modelData.level_id" filterable placeholder="" class="input-select">
                <el-option
                  v-for="item in lists.listLevel"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="facult_id" label="Chọn chuyên ngành" class="form-item">
              <el-select v-model="modelData.facult_id" filterable placeholder="" class="input-select">
                <el-option
                  v-for="item in lists.listFacult"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item prop="date_start" label="Ngày bắt đầu" class="form-item input-daterange">
                  <el-date-picker
                    v-model="modelData.date_start"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="Ngày bắt đầu">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="date_end" label="Ngày kết thúc" class="form-item input-daterange">
                  <el-date-picker
                    v-model="modelData.date_end"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    placeholder="Ngày kết thúc">
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="success"
                  size="small"
                  @click="submitForm('createModel')">Lưu lại</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
            </el-form-item>
          </el-col>
          <el-col :span="16">

          </el-col>
        </el-form>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head, findIndex } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'ConfigmenuCreate',
  metaInfo () {
    return {
      title: 'Lớp học'
    }
  },
  data () {
    return {
      canSubmit: true,
      users: [],
      modelData: {
        school_id: '',
        level_id: '',
        facult_id: '',
        specialized_id: '',
        key_id: '',
        user_id: '',
        name: '',
        code: '',
        status: true,
        date_start: '',
        date_end: ''
      },
      lists: {
        listCategoryBlogs: [
          {key: 1, value: 'Menu chính'},
          {key: 2, value: 'Footer cột Giới thiệu'},
          {key: 3, value: 'Footer cột Cộng tác viên Affiliate'},
          {key: 4, value: 'Footer cột Chính sách'}
        ],
        listSchool: [],
        listLevel: [],
        listFacult: [],
        listSpecialized: [],
        listKey: []
      },
      rules: {
        school_id: [
          { required: true, message: 'Vui lòng nhập trường' }
        ],
        level_id: [
          { required: true, message: 'Vui lòng nhập phân hệ' }
        ],
        facult_id: [
          { required: true, message: 'Vui lòng nhập chuyên ngành' }
        ],
        date_start: [
          {
            dateFrom (val, { date_end }) {
              if (val && date_end) {
                return new Date(date_end) >= new Date(val)
              } else {
                return true
              }
            },
            message: 'Ngày bắt đầu phải nhỏ hơn ngày kết thúc'
          }
        ]
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchSchool()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'class-pros-index', text: 'Lớp học' },
        { name: 'class-pros-create', text: 'Thêm mới' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'class-pros-index'})
    },
    fetchSchool () {
      axios.get('schools', {params: {'status': 1, 'limit': -1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listSchool = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchLevel () {
      let data = {
        'status': 1,
        'limit': -1,
        'school_id': this.modelData.school_id
      }
      axios.get('levels', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listLevel = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchFacult () {
      let data = {
        'status': 1,
        'limit': -1,
        'school_id': this.modelData.school_id,
        'level_id': this.modelData.level_id
      }
      axios.get('facults', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listFacult = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    fetchSpecialized () {
      let data = {
        'status': 1,
        'limit': -1,
        'school_id': this.modelData.school_id,
        'level_id': this.modelData.level_id,
        'facult_id': this.modelData.facult_id
      }
      axios.get('specializeds', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listSpecialized = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    storeModel () {
      this.canSubmit = false
      axios.post('class-pros', this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Thêm thành công',
              type: 'success'
            })
            this.$router.push({name: 'class-pros-update', params: {id: response.data.id}})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  },
  watch: {
    'modelData.school_id': function () {
      if (this.modelData.school_id) {
        this.modelData.level_id = ''
        this.modelData.facult_id = ''
        this.modelData.specialized_id = ''

        this.lists.listLevel = []
        this.lists.listFacult = []
        this.lists.listSpecialized = []
        this.fetchLevel()
      }
    },
    'modelData.level_id': function () {
      if (this.modelData.level_id) {
        this.modelData.facult_id = ''
        this.modelData.specialized_id = ''

        this.lists.listFacult = []
        this.lists.listSpecialized = []
        this.fetchFacult()
      }
    },
    'modelData.facult_id': function () {
      if (this.modelData.facult_id) {
        let _this = this
        let index = findIndex(this.lists.listFacult, function (o) {
          return o.id === _this.modelData.facult_id
        })
        if (index > -1) {
          let facultCurent = this.lists.listFacult[index]
          this.modelData.code = facultCurent.code
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/class-pros/Create.vue